import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import TabButton from './button';

const TabHeader = ({
  anchor,
  index,
  onClick,
  title,
  visibleIndex,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    /**
     * Tabs always require one, and only one, tab to be visible. For that reason,
     * if there are no visible tabs we force the first tab visible. If there are multiple
     * visible tabs, then we force the earliest tab to be visible, and hide the rest.
     *
     * We do this without modifying the visible index array, though, so when resizing to
     * a mobile view, the accordion will remember all the open accordions.
     */
    setIsVisible((
      (
        visibleIndex.length === 0
        && index === 0
      )
      || visibleIndex.sort()[0] === index
    ));
  }, [visibleIndex, index]);

  return (
    <div
      className="tab__container"
      id={anchor}
    >
      <TabButton
        isVisible={isVisible}
        onClick={() => onClick([index])}
        title={title}
      />
    </div>
  );
};

TabHeader.propTypes = {
  anchor: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  visibleIndex: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default TabHeader;
